var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscreenOn = function SvgFullscreenOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.51 12.782.708.708L5.707 19H11v1H4v-7h1v5.291l5.51-5.509zM20 4v7h-1V5.707l-5.51 5.51-.708-.707L18.292 5H13V4h7z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgFullscreenOn;